var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ChatContext as ConversationContext } from '../useChat/ChatContext';
import { useConversationSDK } from './useConversationSDK';
import { chatReducer } from '../../states/reducers';
import { initialState } from '../../states/state';
import { Types } from '../../states/actions';
import { getAPIBaseURL } from '@lendi/lala-utils';
import { useSendBotMessage } from '../useChat/useSendBotMessage/index';
/**
 * `ConversationProvider` Context Provider can be used to exchange data with `chat-service`
 *
 * @param session
 * @param channelId
 */
export var ConversationProvider = function (_a) {
    var children = _a.children, session = _a.session, channelId = _a.channelId, accessToken = _a.accessToken, identity = _a.identity, userType = _a.userType;
    // Create initial chatState
    var _b = React.useReducer(chatReducer, __assign(__assign({}, initialState), { channelId: channelId, accessToken: accessToken, identity: identity })), chatState = _b[0], dispatch = _b[1];
    var environment = session.environment, sessionToken = session.token;
    var apiBaseUrl = getAPIBaseURL(environment);
    useSendBotMessage(chatState, dispatch, sessionToken, apiBaseUrl);
    // useConversationSDK hook to update data with Twilio conversation SDK
    useConversationSDK(chatState, dispatch, sessionToken, apiBaseUrl, userType);
    return (React.createElement(ConversationContext.Provider, { value: __assign(__assign({}, chatState), { retryFetch: function () {
                dispatch({
                    type: Types.RETRY_FETCH,
                });
            } }) }, children));
};
//# sourceMappingURL=ConversationProvider.js.map